import React from "react";

const Observation = ({ observation, setObservation }) => {
  //   //("observation - ------", observation);
  return (
    <div className="mt-[90px]">
      <div className="w-full px-4 flex flex-col gap-4">
        <div className="w-full h-[50px] border rounded">
          <textarea
            placeholder="Enter Observation"
            className="border p-2 h-20 w-full outline-none"
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
          ></textarea>
        </div>
        {/* <div>{observation}</div> */}
      </div>
    </div>
  );
};

export default Observation;
